import React, { useState, useEffect, useCallback } from 'react';
import EditAdult from '../../AddsEdits/Adult/EditAdult.js';
import { SERVER_URL } from '../../../constants.js'
import { formatLocalDateOnly } from '../../shared utils/dateFormatters.js';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { useToast } from '../../shared utils/useToast.js';
import {
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  Box,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';


function AdultDetail(props) {
  const { selectedPerson, selectedStay, setSelectedStay, showFinancials, onClose } = props;
  const [adult, setAdult] = useState(null);
  const { showToast, toastProps } = useToast();
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteConfirmText, setDeleteConfirmText] = useState('');
  const [deleting, setDeleting] = useState(false);
  const REQUIRED_PHRASE = 'delete this adult';

  const handleDeleteAdult = async () => {
    setDeleting(true);
    try {
      const token = sessionStorage.getItem('bearer');
      const res = await fetch(`${SERVER_URL}api/adults/${selectedPerson.id}/full-delete`, {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) throw new Error('Failed to delete adult');
      setDeleteDialogOpen(false);
      showToast('Adult deleted successfully.', 'success');
      setTimeout(() => onClose?.(), 1000);
    } catch (err) {
      console.error(err);
      showToast('Failed to delete adult.', 'error');
    } finally {
      setDeleting(false);
    }
  };

  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });
  
  const fetchStays = useCallback(() => {
    const token = sessionStorage.getItem('bearer');
    fetch(`${SERVER_URL}api/student/${selectedPerson.id}/stays`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        if (response.status === 204) {
          return [];
        } else if (response.ok) {
          return response.json();
        } else {
          throw new Error('Failed to fetch stays');
        }
      })
      .then((data) => {
        // Automatically select the most recent stay if none is currently selected
        if (!selectedStay && data.length > 0) {
          setSelectedStay(data[data.length - 1]);  // Set to the most recent stay
          //console.log(selectedStay);
        }
      })
      .catch((err) => console.error(err));
  }, [selectedPerson.id, selectedStay, setSelectedStay]);

  const fetchAdult = useCallback(() => {
    const token = sessionStorage.getItem('bearer');
    fetch(`${SERVER_URL}api/adult/${selectedPerson.id}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        if (response.status === 204) {
          return null;
        } else if (response.ok) {
          return response.json();
        } else {
          throw new Error('Failed to fetch adult');
        }
      })
      .then((data) => {
        setAdult(data);
      })
      .catch((err) => console.error(err));
  }, [selectedPerson.id]);

  useEffect(() => {
    fetchAdult();
    fetchStays();
  }, [fetchAdult, fetchStays]);

  let imgPath= process.env.PUBLIC_URL || '/assets/img/details.png';
  console.log(imgPath);

  const {
    id, 
    dateAdded, 
    adultName, 
    adultSurname, 
    adultEmail, 
    adultPhone, 
    adultNationality, 
    allergies, 
    notes
  } = adult || {};

  const editAdult = (adult, id) => {
    const formattedAdult = {
      ...adult,
      dateAdded: formatLocalDateOnly(adult.dateAdded),
    };
    const token = sessionStorage.getItem("bearer"); 
    fetch(`${SERVER_URL}api/adults/${id}`, {
      method: 'PUT', 
      headers: {
        'Content-Type':'application/json',
        'Authorization' : `Bearer ${token}`
      },
      body: JSON.stringify(formattedAdult)
    })
    .then(response => {
      if (response.ok) {
        fetchAdult();
      }
      else {
        alert('Something went wrong!');
      }
    })
    .catch(err => console.error(err))
  }

  return (
    <React.Fragment>
      <div className="detail-card" style={{ padding: '20px 0' }}>
        <table style={{ width: '80%', textAlign: 'left', margin: 'auto', borderCollapse: 'collapse' }}>
          <tbody>
            <tr>
              <td rowSpan="2" style={{ textAlign: 'center' }}><img className="br-0 h3 w3 dib" alt={selectedPerson.id} src={imgPath} /></td>
              <td>DB ref: {id}</td>
              <td>Added: {dateAdded}</td>
            </tr>
            <tr>
            <td style={{ textAlign: 'left' }}>{adultName} {adultSurname}</td>
            <td>Nationality: {adultNationality}</td>
            </tr>
            <tr>
            
              
              <td colSpan="1"></td>
              <td>Email: {adultEmail}</td>
            <td>Phone: {adultPhone}</td>
            </tr>
            <tr style={{ height: '50px' }}><td colSpan="4" > </td></tr>
            <tr><td>Allergies: </td><td colSpan="3">{allergies}</td></tr>
            <tr><td>Notes: </td><td colSpan="3">{notes}</td></tr>
          </tbody>
        </table>
      </div>
      <div>
        <div style={{ color: '#999999', fontSize: '10px' }}>Adult: {selectedPerson.id}
          <EditAdult adultToEdit={adult} updateAdult={editAdult} />
        </div>
        <div style={{ color: '#999999', fontSize: '10px' }}>Is authenticated: {sessionStorage.getItem('isAuthenticated') ? 'Yes' : 'No'}</div>
      </div>
      {showFinancials && (
        <>
          <Box sx={{ mt: 3, p: 2, border: '1px solid #f44336', borderRadius: 1, bgcolor: '#ffebee', maxWidth: '80%', mx: 'auto' }}>
            <Typography variant="subtitle2" sx={{ color: '#b71c1c', mb: 1 }}>
              Danger Zone
            </Typography>
            <IconButton
              color="error"
              onClick={() => { setDeleteConfirmText(''); setDeleteDialogOpen(true); }}
              title="Delete this adult"
              size="small"
            >
              <DeleteIcon />
            </IconButton>
            <Typography variant="caption" sx={{ color: '#b71c1c', ml: 1 }}>
              Permanently delete this adult and all associated data
            </Typography>
          </Box>

          <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
            <DialogTitle sx={{ color: '#b71c1c' }}>Delete Adult</DialogTitle>
            <DialogContent>
              <Typography sx={{ mb: 2 }}>
                This will permanently delete <strong>{adult?.adultName} {adult?.adultSurname}</strong> (ID: {selectedPerson.id}) and all their stays, transfers, and associated data.
              </Typography>
              <Typography sx={{ mb: 2 }}>
                Type <strong>{REQUIRED_PHRASE}</strong> to confirm:
              </Typography>
              <TextField
                fullWidth
                value={deleteConfirmText}
                onChange={(e) => setDeleteConfirmText(e.target.value)}
                placeholder={REQUIRED_PHRASE}
                autoFocus
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setDeleteDialogOpen(false)} disabled={deleting}>Cancel</Button>
              <Button
                color="error"
                variant="contained"
                onClick={handleDeleteAdult}
                disabled={deleteConfirmText !== REQUIRED_PHRASE || deleting}
                startIcon={<DeleteIcon />}
              >
                {deleting ? 'Deleting...' : 'Delete'}
              </Button>
            </DialogActions>
          </Dialog>
        </>
      )}

      <Snackbar {...toastProps}>
        <Alert onClose={toastProps.onClose} severity={toastProps.severity}>
          {toastProps.message}
        </Alert>
      </Snackbar>
    </React.Fragment>
  );
}

export default AdultDetail;
